// extracted by mini-css-extract-plugin
export default {"button":"SelectionActionButton_button__LsZXulwJ","icon":"SelectionActionButton_icon__eOjtPP2-","text":"SelectionActionButton_text__miEQ+K7n"};